export const MVP_DEVICE_COMBOS = [
  'Phone only',
  'Laptop only',
  'Phone + Laptop',
];

/** i18n keys for device combo labels (value stays exact match for Dify KB). */
export const MVP_DEVICE_COMBO_I18N_KEYS = {
  'Phone only': 'device_combo_phone_only',
  'Laptop only': 'device_combo_laptop_only',
  'Phone + Laptop': 'device_combo_phone_laptop',
};

export function getDeviceComboStorageKey(sessionId) {
  return `mvp:prejoin:deviceCombo:${sessionId || ''}`;
}
